const hero = document.querySelector('.hero-search');

if(hero) {
  const input = hero.querySelector('.hero-search__search-input');
  const button = hero.querySelector('.hero-search__submit');
  
  if (input && button) {
    function updateInputState() {
      if (input.value.trim() !== '') {
        button.classList.add('hero-search__submit--value');
      } else {
        button.classList.remove('hero-search__submit--value');
      }
    }
  
    input.addEventListener('input', updateInputState);
    updateInputState();
  }
}
